<template>
	<div>
		<a-modal title="选择审批单" :visible="is_revocation" width="70%" @cancel="is_revocation = false">
			<template slot="footer">
				<a-button key="back" @click="is_revocation = false"> 取消 </a-button>
				<a-button key="submit" type="primary" @click="selectCode"> 确定 </a-button>
			</template>
			<!-- <a-select show-search allowClear style="width: 200px;margin: 10px;" v-model="type3" placeholder="关联审批单类型">
						<a-select-option :value="item.id" v-for="(item, index) in Approvallist" :key="index">
							{{ item.name }}
						</a-select-option>
					</a-select>
					<a-button type="primary" @click="get_mylis"> 查询 </a-button> -->
			<a-tabs :default-active-key="activeKey" @change="callback">
				<a-tab-pane key="1" tab="我的待办">
					<a-table :data-source="lis1" bordered :pagination="pagination1" rowKey="id" @change="handleTableChange" :loading="boo"
					 :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }" :scroll="{ y: 400, scrollToFirstRowOnChange: true }">
						<a-table-column key="index" title="序号" data-index="index" width="70px">
							<template scope="text, record, index">{{ (pagination1.current - 1) * 10 + index + 1 }}</template>
						</a-table-column>
						<a-table-column key="applyCode" title="申请单号" data-index="applyCode" />
						<a-table-column key="applyer" title="申请人" data-index="applyer" />
						<a-table-column key="createTime" title="申请时间" data-index="createTime" />
						<a-table-column key="processName" title="申请标题" data-index="processName" />
						<a-table-column title="操作" width="120px">
							<template scope="text,record">
								<!-- <a @click="show_details(record)">选择单号</a> -->
								<a @click="showDaildb(record)">详情</a>
							</template>
						</a-table-column>
					</a-table>
				</a-tab-pane>
				<a-tab-pane key="2" tab="我的已办" force-render>
					<a-table :data-source="lis2" bordered :pagination="pagination2" rowKey="id" @change="handleTableChange2" :loading="boo"
					 :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange2 }" :scroll="{ y: 400, scrollToFirstRowOnChange: true }">
						<a-table-column key="index" title="序号" data-index="index" width="70px">
							<template scope="text, record, index">{{ (pagination2.current - 1) * 10 + index + 1 }}</template>
						</a-table-column>
						<a-table-column key="applyCode" title="申请单号" data-index="applyCode" />
						<a-table-column key="applyer" title="申请人" data-index="applyer" />
						<a-table-column key="startTime" title="申请时间" data-index="startTime" />
						<a-table-column key="title" title="申请标题" data-index="title" />
						<a-table-column title="操作" width="120px">
							<template scope="text,record">
								<!-- <a @click="show_details(record)">选择单号</a> -->
								<a @click="showDail2(record)">详情</a>
							</template>
						</a-table-column>
					</a-table>
				</a-tab-pane>
				<a-tab-pane key="3" tab="我的申请">
					<a-table :data-source="lis3" bordered :pagination="pagination3" rowKey="id" @change="handleTableChange3" :loading="boo"
					 :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange3 }" :scroll="{ y: 400, scrollToFirstRowOnChange: true }">
						<a-table-column key="index" title="序号" data-index="index" width="70px">
							<template scope="text, record, index">{{ (pagination3.current - 1) * 10 + index + 1 }}</template>
						</a-table-column>
						<a-table-column key="applyCode" title="申请单号" data-index="applyCode" />
						<a-table-column key="applyer" title="申请人" data-index="applyer" />
						<a-table-column key="applyTime" title="申请时间" data-index="applyTime" />
						<a-table-column key="title" title="申请标题" data-index="title" />
						<a-table-column title="操作" width="120px">
							<template scope="text,record">
								<!-- <a @click="show_details(record)">选择单号</a> -->
								<a @click="showDail(record)">详情</a>
							</template>
						</a-table-column>
					</a-table>
				</a-tab-pane>
				<a-tab-pane key="4" tab="抄送我的">
					<a-table :data-source="lis4" bordered :pagination="pagination4" rowKey="id" @change="handleTableChange4" :loading="boo"
					 :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange4 }" :scroll="{ y: 400, scrollToFirstRowOnChange: true }">
						<a-table-column key="index" title="序号" data-index="index" width="70px">
							<template scope="text, record, index">{{ (pagination4.current - 1) * 10 + index + 1 }}</template>
						</a-table-column>
						<a-table-column key="applyCode" title="申请单号" data-index="applyCode" />
						<a-table-column key="applyer" title="申请人" data-index="applyer" />
						<a-table-column key="applyTime" title="申请时间" data-index="applyTime" />
						<a-table-column key="title" title="申请标题" data-index="title" />
						<a-table-column title="操作" width="120px">
							<template scope="text,record">
								<!-- <a @click="show_details(record)">选择单号</a> -->
								<a @click="showDail2(record)">详情</a>
							</template>
						</a-table-column>
					</a-table>
				</a-tab-pane>
			</a-tabs>
		</a-modal>
		<leave-modal ref="leavemodal" @ok="handleOk" :audit="false" />
		<purchase-modal ref="purchasemodal" @ok="handleOk" :audit="false" />
		<proc-flow-modal ref="modal" @ok="handleOk" :audit="false" />
		<!-- 报废 -->
		<scrap-modal ref="scrapmodal" @ok="handleOk" :audit="false" />
		<!-- 审批领用 -->
		<receive-modal ref="receiveModal" @ok="handleOk" :audit="false" />
		<operation-modal ref="operationmodal" @ok="handleOk" :audit="false" />
		<service-modal ref="servicemodal" @ok="handleOk" :audit="false" />
		<reimbursement-modal ref="reimbursementmodal" @ok="handleOk" :audit="false" />
		<!-- 详情 -->
		<payMentModal ref="paymentmodal" @ok="handleOk" :audit="false" />
		<!-- 详情 -->
		<contractModal ref="contractmodal" @ok="handleOk" :audit="false" />
		<sealModal ref="sealmodal" @ok="handleOk" :audit="false" />
		<currencyModal ref="currencymodal" @ok="handleOk" :audit="false" />
		<returnModal ref="returnmodal" @ok="handleOk" :audit="false" />
		<car-modal ref="carmodal" @ok="handleOk" :audit="false" />
		<returncar-modal ref="returncarmodal" @ok="handleOk" :audit="false" />
		<salaryModal ref="salarymodal" @ok="handleOk" :audit="false" />
		<adjustmentModal ref="adjustmentmodal" @ok="handleOk" :audit="false" />
		<charge-modal ref="chargemodal" @ok="handleOk" :audit="false" />
		<other-modal ref="othermodal" @ok="handleOk" :audit="false" />
		<feedback-modal ref="feedbackmodal" @ok="handleOk" :audit="false" />
	</div>
</template>
<script>
	import {
		getTasking,
		getTaskdone,
		getBusinessListMy,
		getTaskdone_cc,
		modalMap
	} from '@/api/activiti'
	import {
		audit_list,
	} from '@/api/financial'
	import LeaveModal from '@/views/activiti/modules/LeaveModal.vue'
	import PurchaseModal from '@/views/activiti/modules/PurchaseModal.vue'
	import ProcFlowModal from '@/views/activiti/modules/ProcFlowModal.vue'
	import receiveModal from '@/views/activiti/modules/receiveModal.vue' //领用
	import ScrapModal from '@/views/activiti/modules/ScrapModal.vue' //报废
	import OperationModal from '@/views/activiti/modules/OperationModal.vue'
	import ServiceModal from '@/views/activiti/modules/ServiceModal.vue'
	import ReimbursementModal from '@/views/activiti/modules/ReimbursementModal.vue'
	import payMentModal from '@/views/activiti/modules/payMentModal.vue'
	import contractModal from '@/views/activiti/modules/contractModal.vue'
	import sealModal from '@/views/activiti/modules/sealModal.vue'
	import currencyModal from '@/views/activiti/modules/currencyModal.vue'
	import returnModal from '@/views/activiti/modules/returnModal.vue'
	import carModal from '@/views/activiti/modules/carModal.vue'
	import returncarModal from '@/views/activiti/modules/returncarModal.vue'
	import salaryModal from '@/views/activiti/modules/salaryModal.vue'
	import adjustmentModal from '@/views/activiti/modules/adjustmentModal.vue'
	import chargeModal from '@/views/activiti/modules/chargeModal.vue'
	import otherModal from '@/views/activiti/modules/otherModal.vue'
	import feedbackModal from '@/views/activiti/modules/feedbackModal.vue'
	export default {
		components: {
			LeaveModal,
			ProcFlowModal,
			PurchaseModal,
			receiveModal,
			ScrapModal,
			OperationModal,
			ServiceModal,
			ReimbursementModal,
			payMentModal,
			contractModal,
			sealModal,
			currencyModal,
			returnModal,
			carModal,
			returncarModal,
			salaryModal,
			adjustmentModal,
			chargeModal,
			otherModal,
			feedbackModal
		},
		data() {
			return {
				selectedRowKeys: [],
				Approvallist: [],
				rowInfo: [],
				rowInfo2: [],
				rowInfo3: [],
				rowInfo4: [],
				activeKey: '1',
				is_revocation: false,
				type: undefined,
				type2: undefined,
				type3: undefined,
				pagination1: {
					current: 1,
					pageSize: 30,
					total: 0,
					pageSizeOptions: ['10', '20', '30', '40', '50'],
					showLessItems: true,
					showSizeChanger: true,
					itemName: '',
				},
				lis1: [],
				pagination2: {
					current: 1,
					pageSize: 30,
					total: 0,
					pageSizeOptions: ['10', '20', '30', '40', '50'],
					showLessItems: true,
					showSizeChanger: true,
					itemName: '',
				},
				lis2: [],
				pagination3: {
					current: 1,
					pageSize: 30,
					total: 0,
					pageSizeOptions: ['10', '20', '30', '40', '50'],
					showLessItems: true,
					showSizeChanger: true,
					itemName: '',
				},
				lis3: [],
				pagination4: {
					current: 1,
					pageSize: 30,
					total: 0,
					pageSizeOptions: ['10', '20', '30', '40', '50'],
					showLessItems: true,
					showSizeChanger: true,
					itemName: '',
				},
				lis4: [],
				boo:false
			}
		},
		props: {
			data: {
				type: Object,
				default: true,
			},
		},
		watch: {
			data(val, old) {
				console.log(val, old)
			},
		},
		created() {

		},
		methods: {
			show(key) {
				this.rowInfo = []
				this.rowInfo2 = []
				this.rowInfo3 = []
				this.rowInfo4 = []
				this.selectedRowKeys = []
				console.log(this.data)
				this.data.auditCodeData.forEach(item => {
					this.selectedRowKeys.push(item.id)
				})
				this.data.auditCodeData2.forEach(item => {
					this.selectedRowKeys.push(item.id)
				})
				this.data.auditCodeData3.forEach(item => {
					this.selectedRowKeys.push(item.id)
				})
				this.data.auditCodeData4.forEach(item => {
					this.selectedRowKeys.push(item.id)
				})
				this.getAll()
			},
			//获取所有
			getAll() {
				this.get_ing()
				this.get_done()
				this.get_mylis()
				this.get_Taskdone()
				this.aut()
				this.is_revocation = true
			},
			aut() {
				audit_list().then(res => {
					this.Approvallist = res.data
				})
			},
			//我的待办
			get_ing() {
				this.boo=true
				getTasking({
					pageNum: this.pagination1.current,
					pageSize: this.pagination1.pageSize,
					sortField: 'applyTime',
					sortOrder: 'desc',
					processDefKeys: 'carApply',
					processName: this.pagination1.itemName,
				}).then((res) => {
					const pagination1 = { ...this.pagination1
					}
					pagination1.total = res.total
					this.pagination1 = pagination1
					this.lis1 = res.rows
					this.boo=false
				})
			},
			//改变分页
			handleTableChange(pagination, filters, sorter) {
				this.pagination1.current = pagination.current
				this.get_ing()
			},
			//我的已办
			get_done() {
				this.boo=true
				getTaskdone({
					pageNum: this.pagination2.current,
					pageSize: this.pagination2.pageSize,
					sortField: 'endTime',
					sortOrder: 'desc',
					procDefKey: 'carApply',
					title: this.pagination2.itemName,
				}).then((res) => {
					const pagination2 = { ...this.pagination2
					}
					pagination2.total = res.total
					this.pagination2 = pagination2
					this.lis2 = res.rows
					this.boo=false
				})
			},
			handleTableChange2(pagination, filters, sorter) {
				this.pagination2.current = pagination.current
				this.get_done()
			},
			//我的申请
			get_mylis() {
				this.boo=true
				getBusinessListMy({
					pageNum: this.pagination3.current,
					pageSize: this.pagination3.pageSize,
					procDefKey: 'carApply',
					sortField: 'id',
					sortOrder: 'desc',
					searchValue: this.pagination3.itemName,
				}).then((res) => {
					const pagination3 = { ...this.pagination3
					}
					pagination3.total = res.total
					this.pagination3 = pagination3
					this.lis3 = res.rows
					this.boo=false
				})
			},
			//抄送我的
			get_Taskdone() {
				this.boo=true
				getTaskdone_cc({
					pageNum: this.pagination4.current,
					pageSize: this.pagination4.pageSize,
					procDefKey: 'carApply',
					sortField: 'id',
					sortOrder: 'desc',
					searchValue: this.pagination4.itemName,
				}).then((res) => {
					const pagination4 = { ...this.pagination3
					}
					pagination4.total = res.total
					this.pagination4 = pagination4
					this.lis4 = res.rows
					this.boo=false
				})
			},
			handleTableChange3(pagination, filters, sorter) {
				this.pagination3.current = pagination.current
				this.get_mylis()
			},
			handleTableChange4(pagination, filters, sorter) {
				this.pagination4.current = pagination.current
				this.get_Taskdone()
			},
			callback(res) {
				this.activeKey = res
			},
			//显示详情
			showDail(row) {
				var modal = modalMap[row.procDefKey]
				this.$refs[modal].show({
					businessKey: row.id,
				})
			},
			//显示详情
			showDail2(row) {
				var modal = modalMap[row.procDefKey]
				this.$refs[modal].show({
					businessKey: row.businessKey,
				})
			},
			showDaildb(row) {
				var modal = modalMap[row.processDefKey]
				this.$refs[modal].show({
					businessKey: row.businessKey,
				})
			},
			onSelectChange(l, s) {
				// this.selectedRowKeys = l
				// this.rowInfo = s
				var arr = JSON.parse(JSON.stringify(s))
				this.rowInfo = this.rowInfo.concat(arr)
				this.selectedRowKeys = l
				var obj = {}
				this.rowInfo = this.rowInfo.reduce(function(item, next) {
					obj[next.id] ? '' : (obj[next.id] = true && item.push(next))
					return item
				}, [])
				var newLis = []
				this.selectedRowKeys.forEach((key, idx) => {
					this.rowInfo.forEach((item, index) => {
						if (key == item.id) {
							newLis.push(item)
						}
					})
				})
				this.rowInfo = newLis
			},
			onSelectChange2(l, s) {
				// this.selectedRowKeys = l
				// this.rowInfo2 = s
				var arr = JSON.parse(JSON.stringify(s))
				this.rowInfo2 = this.rowInfo2.concat(arr)
				this.selectedRowKeys = l
				var obj = {}
				this.rowInfo2 = this.rowInfo2.reduce(function(item, next) {
					obj[next.id] ? '' : (obj[next.id] = true && item.push(next))
					return item
				}, [])
				var newLis = []
				this.selectedRowKeys.forEach((key, idx) => {
					this.rowInfo2.forEach((item, index) => {
						if (key == item.id) {
							newLis.push(item)
						}
					})
				})
				this.rowInfo2 = newLis
			},
			onSelectChange3(l, s) {
				var arr = JSON.parse(JSON.stringify(s))
				this.rowInfo3 = this.rowInfo3.concat(arr)
				this.selectedRowKeys = l
				var obj = {}
				this.rowInfo3 = this.rowInfo3.reduce(function(item, next) {
					obj[next.id] ? '' : (obj[next.id] = true && item.push(next))
					return item
				}, [])
				var newLis = []
				this.selectedRowKeys.forEach((key, idx) => {
					this.rowInfo3.forEach((item, index) => {
						if (key == item.id) {
							newLis.push(item)
						}
					})
				})
				this.rowInfo3 = newLis
			},
			onSelectChange4(l, s) {
				var arr = JSON.parse(JSON.stringify(s))
				this.rowInfo4 = this.rowInfo4.concat(arr)
				this.selectedRowKeys = l
				var obj = {}
				this.rowInfo4 = this.rowInfo4.reduce(function(item, next) {
					obj[next.id] ? '' : (obj[next.id] = true && item.push(next))
					return item
				}, [])
				var newLis = []
				this.selectedRowKeys.forEach((key, idx) => {
					this.rowInfo4.forEach((item, index) => {
						if (key == item.id) {
							newLis.push(item)
						}
					})
				})
				this.rowInfo4 = newLis
			},
			//选择单号
			selectCode() {
				this.$emit('applyData', this.rowInfo)
				this.$emit('applyData2', this.rowInfo2)
				this.$emit('applyData3', this.rowInfo3)
				this.$emit('applyData4', this.rowInfo4)
				var rowAll = this.rowInfo.concat(this.rowInfo2, this.rowInfo3, this.rowInfo4)
				this.$emit('applyAll', rowAll)
				this.is_revocation = false
			},
		},
	}
</script>
